
function addItemToCart(variant_id, qty, selling_plan, variant_name) {

    data = {
      "id": variant_id,
      "quantity": qty,
      "selling_plan": selling_plan
    }
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() { 
        //window.location.href = '/cart';
        toggleCartNotification(variant_name);
      }
    });
  }

function toggleCartNotification(name) {
  	hideCartNotification();
	setTimeout(function(){ showCartNotification(name) }, 50);
}

function showCartNotification(name) {
	var notify = document.getElementById("cartnotificationbar");
    notify.innerHTML = "Added " + name + " Subscription To Cart!";
  
  	switch (name)
    {
      case "Immunity":
          notify.style.backgroundColor = "#8a9c84";
          break;
      case "Inner Peace":
          notify.style.backgroundColor = "#9ba2ba";
          break;
      case "Inner Warrior":
          notify.style.backgroundColor = "#b25158";
          break;
      case "Mastermind":
          notify.style.backgroundColor = "#bc8479";
          break;
      case "Mushroom Magic":
          notify.style.backgroundColor = "#66729c";
          break;
    }
  
    notify.style.display = "block";
  
  	$("#CartCount").removeClass("hide");
  
  	var cartspan = $('#CartCount span').first();
    cartspan.text(String(parseInt(cartspan.text()) + 1));
  
  	
    setTimeout(function(){ hideCartNotification() }, 60000);
}

function hideCartNotification() {
	var notify = document.getElementById("cartnotificationbar");
    notify.style.display = "none";
}